import React from "react";

import { Avatar, Icon } from "../components/ui";

/**
 * Identity bar above the thread — who you are talking to, and what kind of
 * channel it is.
 *
 * Laptop only. On phones the page header already shows the channel name with
 * the back arrow, so rendering this there would print the name twice and eat
 * a quarter of a small screen; the hiding is done in SCSS with the same md
 * breakpoint the two-pane split uses.
 *
 * Actions deliberately do NOT live here. The one action a master admin has —
 * sharing a meeting link — sits in the composer beside the paperclip, because
 * it produces a message. Putting it here as well would mean two placements to
 * keep in step for no gain.
 */
const ThreadHeader = ({ channel }) => {
  const isUpdates = channel.type === "updates";

  return (
    <header className="rc-chat__header">
      <Avatar
        name={channel.store?.name || channel.name}
        variant={isUpdates ? "user" : "store"}
        master={isUpdates}
        size="md"
      />

      {/* Name only. The store name and a "Synced with Roam" note used to sit
          under it; both were removed on Alex's call (2026-10-01) — the store
          name is already inside the channel name, and the Roam bridge is an
          implementation detail a merchant does not need reminding of. */}
      <h2 className="rc-chat__header-name">{channel.name}</h2>

      {/* A channel with no Roam group still works in-app, so this is a
          status note rather than an error — but it is worth surfacing,
          because messages sent here will not reach the Roam side. */}
      {!channel.is_provisioned && (
        <span className="rc-chat__header-flag" title="This channel has no Roam group yet">
          <Icon name="AlertTriangle" size="xs" /> Pending Roam
        </span>
      )}
    </header>
  );
};

export default ThreadHeader;
